import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button, ButtonBase, ClickAwayListener, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Popper, Stack, Typography } from '@mui/material';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
// project import
import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';

// assets
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { colors } from 'utils/consts';
import useStore from 'zustand-store';

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const Profile = () => {
  const { firstName, lastName } = useStore(state => state.loggedUser)
  const logout = useStore(state => state.logout);

  const theme = useTheme();
  const navigate = useNavigate();
  const handleLogout = async () => {
    setLogOutDialogOpen(false);
    logout();
  };

  const anchorRef = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const [logOutDialogOpen, setLogOutDialogOpen] = useState(false)
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleLogOutDialogClose = () => {
    setLogOutDialogOpen(false)
  };

  const handleClickLogOutDialogOpen = () => {
    setOpen(false)
    setLogOutDialogOpen(true)
  };

  return (
    <>
      <Box sx={{ flexShrink: 0, ml: 0.75 }}>
        <ButtonBase
          sx={{
            p: 0.25,
            bgcolor: open ? 'grey.300' : 'transparent',
            borderRadius: 1,
            '&:hover': { bgcolor: 'secondary.lighter' },
            '&:focus-visible': {
              outline: `2px solid ${theme.palette.secondary.dark}`,
              outlineOffset: 2
            }
          }}
          aria-label="open profile"
          ref={anchorRef}
          aria-controls={open ? 'profile-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <Stack direction="row" spacing={1} alignItems="center" sx={{ p: 0.5 }}>
            <Avatar size="sm" style={{ backgroundColor: colors.light_grey, color: colors.bold_grey }} />
            <Typography variant="subtitle1">{firstName + " " + lastName}</Typography>
          </Stack>
        </ButtonBase>
        <Popper
          placement="bottom-end"
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          popperOptions={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 9]
                }
              }
            ]
          }}
        >
          {({ TransitionProps }) => (
            <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
              <Paper
                sx={{
                  boxShadow: theme.customShadows.z1,
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <MainCard elevation={0} border={false} content={false}>
                    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
                      <ListItemButton onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                        navigate(`/profile`)
                        setOpen(false);
                      }}>
                        <ListItemIcon sx={{ color: "#1890FF" }}>
                          <PersonOutlineOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText primary="Voir Profile" />
                      </ListItemButton>
                      <ListItemButton onClick={handleClickLogOutDialogOpen}>
                        <ListItemIcon sx={{ color: "red" }}>
                          <LogoutOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText primary="Déconnexion" />
                      </ListItemButton>
                    </List>
                  </MainCard>
                </ClickAwayListener>
              </Paper>
            </Transitions>
          )}
        </Popper>
      </Box>
      <Dialog
        open={logOutDialogOpen}
        onClose={handleLogOutDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Déconnexion
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Êtes-vous sûr de vouloir vous déconnecter ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disableElevation onClick={handleLogOutDialogClose}>Annuler</Button>
          <Button disableElevation autoFocus onClick={handleLogout}>Oui</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Profile;
